module.exports = __webpack_public_path__ + "static/img/close.3c65cb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = mq5u
// module chunks = 1